<template>
  <div class="select-k2sv-modal">
    <div class="select-k2sv-modal__hint q-mb-md">
      <q-icon name="info" color="blue-5" size="18px" />
      <span>Выберите подписанный КС-2В без АВР</span>
    </div>

    <q-table
      :rows="rows"
      :columns="columns"
      row-key="floor_map_document_id"
      flat bordered
      :loading="loading"
      :rows-per-page-options="[0]"
      hide-bottom
      class="select-k2sv-modal__table"
      no-data-label="Нет подписанных КС-2В без АВР в текущих фильтрах"
    >
      <template #body-cell-doc_id="props">
        <q-td :props="props">
          <span class="cd-code">{{ props.row.floor_map_document_id }}</span>
          <div v-if="props.row.avr_code" class="text-caption text-grey-6">{{ props.row.avr_code }}</div>
        </q-td>
      </template>

      <template #body-cell-project="props">
        <q-td :props="props">
          <div class="text-body2 text-weight-medium">{{ projectLineMain(props.row) }}</div>
          <div v-if="projectLineSub(props.row)" class="text-caption text-grey-6">{{ projectLineSub(props.row) }}</div>
        </q-td>
      </template>

      <template #body-cell-contractor="props">
        <q-td :props="props" class="select-k2sv-modal__td-contractor">
          <div class="select-k2sv-modal__contractor-name">{{ props.row.contractor_name || '—' }}</div>
        </q-td>
      </template>

      <template #body-cell-agreement_num="props">
        <q-td :props="props">{{ props.row.agreement_num || '—' }}</q-td>
      </template>

      <template #body-cell-sum="props">
        <q-td :props="props" class="text-right">{{ formatSum(props.row.avr_sum) }}</q-td>
      </template>

      <template #body-cell-date="props">
        <q-td :props="props">{{ props.row.doc_date || '—' }}</q-td>
      </template>

      <template #body-cell-actions="props">
        <q-td :props="props" class="text-center">
          <q-btn
            unelevated dense no-caps
            label="Выбрать"
            color="primary" text-color="white" size="sm"
            style="min-width: 72px"
            @click="select(props.row)"
          />
        </q-td>
      </template>
    </q-table>

    <div class="select-k2sv-modal__footer">
      <q-btn flat label="Закрыть" @click="$emit('close')" />
    </div>
  </div>
</template>

<script>
import { getClosingDocuments, closingDocumentsRowFullySigned } from "@/views/ClosingDocuments/services";

export default {
  name: "SelectK2svForAvrModal",

  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
  },

  emits: ["selected", "close"],

  data() {
    return {
      loading: false,
      rows: [],
      columns: [
        { name: "doc_id",     label: "№",           field: "floor_map_document_id", align: "left",  sortable: true },
        { name: "date",       label: "Дата",         field: "doc_date",              align: "left",  sortable: true },
        { name: "project",    label: "Проект",       field: "project_name",          align: "left",  sortable: true },
        { name: "contractor", label: "Контрагент", field: "contractor_name", align: "left", sortable: false, classes: "select-k2sv-modal__col-contractor" },
        { name: "agreement_num", label: "Номер договора", field: "agreement_num",  align: "left",  sortable: false },
        { name: "sum",        label: "Сумма",        field: "avr_sum",               align: "right", sortable: true },
        { name: "actions",    label: "",             field: "",                       align: "center", sortable: false },
      ],
    };
  },

  async mounted() {
    await this.load();
  },

  methods: {
    async load() {
      this.loading = true;
      try {
        const params = { doc_type: "K2SV" };
        if (this.filters.resident_id)     params.resident_id     = this.filters.resident_id;
        if (this.filters.project_type_id) params.project_type_id = this.filters.project_type_id;
        if (this.filters.contractor_id)   params.contractor_id   = this.filters.contractor_id;
        if (this.filters.block_name)      params.block_name      = this.filters.block_name;
        if (this.filters.level_num)       params.level_num       = this.filters.level_num;

        const res = await getClosingDocuments(params);
        const all = res?.data || [];
        this.rows = all.filter((r) => {
          return r.followup_pending === true && closingDocumentsRowFullySigned(r);
        });
      } finally {
        this.loading = false;
      }
    },

    select(row) {
      this.$emit("selected", row);
    },

    validProjectName(row) {
      const n = row?.project_name != null ? String(row.project_name).trim() : "";
      if (!n || n === "Нет названия") return "";
      return n;
    },

    /** ЖК / название без «Нет названия», как в основной таблице. */
    projectLineMain(row) {
      if (!row) return "—";
      if (row.resident_name) return String(row.resident_name).trim();
      const v = this.validProjectName(row);
      return v || "—";
    },

    projectLineSub(row) {
      if (!row) return "";
      const v = this.validProjectName(row);
      if (row.resident_name && v) return v;
      return "";
    },

    formatSum(val) {
      if (val == null || val === "") return "—";
      const n = parseFloat(val);
      if (!Number.isFinite(n)) return "—";
      return n.toLocaleString("ru-RU", { maximumFractionDigits: 0 }) + " тг";
    },
  },
};
</script>

<style lang="scss" scoped>
.select-k2sv-modal {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  max-height: min(78vh, 820px);
  display: flex;
  flex-direction: column;
  gap: 0;

  &__hint {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #475569;
  }

  &__table {
    flex: 1;
    overflow-y: auto;
    border-radius: 8px;

    :deep(th.select-k2sv-modal__col-contractor),
    :deep(td.select-k2sv-modal__col-contractor) {
      max-width: 260px;
      vertical-align: top;
      white-space: normal;
    }
  }

  &__td-contractor {
    max-width: 260px;
    vertical-align: top;
    white-space: normal;
  }

  &__contractor-name {
    line-height: 1.35;
    overflow-wrap: anywhere;
    word-break: normal;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    padding-top: 16px;
    border-top: 1px solid #e0e0e0;
    margin-top: 12px;
  }
}

.cd-code {
  font-family: monospace;
  font-size: 12px;
  font-weight: 600;
  color: #334155;
  background: #f1f5f9;
  border-radius: 4px;
  padding: 2px 6px;
  display: inline-block;
}
</style>
